import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../shared/Navbar';
import './LandingPage.css';
import { LearningNav, LearningFooter } from './LearningPageSections';

export default function EducatorsPage() {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = 'For Educators | TeachMeNow';
    return () => { document.title = previousTitle; };
  }, []);

  return (
    <div className="lp-root learning-page">
      <Navbar />
      <LearningNav />
      <main>
        <section className="learning-hero tm-shell">
          <div className="learning-hero-copy">
            <h1>Learning continues after the lesson ends.</h1>
            <p>Set structured lessons or practice tests as homework, give students AI support as they work, and review their thinking before your next class.</p>
            <div className="learning-actions">
              <Link className="tm-button tm-button--primary" to="/subjects">Explore courses for your class <span aria-hidden="true">→</span></Link>
            </div>
            <p>If you’re an educator or institution interested in using TeachMeNow, contact us at <a className="learning-text-link" href="mailto:contact@teachmenow.ai">contact@teachmenow.ai</a> to discuss how we can support your students.</p>

          </div>
          <aside className="learning-example" aria-label="A teaching workflow with TeachMeNow">

            <ol className="educator-workflow">
              <li><strong>You choose the focus</strong><p>Select a lesson or practice test from a course that fits your teaching.</p></li>
              <li><strong>Students learn by doing</strong><p>We give students immediate feedback and answer their questions.</p></li>
              <li><strong>You decide what comes next</strong><p>We help you review their progress so you can plan a recap lesson or provide individual support.</p></li>
            </ol>
          </aside>
        </section>

        <section className="learning-section tm-shell" aria-labelledby="educator-benefits">
          <div className="learning-section-heading">

            <h2 id="educator-benefits">Useful practice for students. Useful insight for you.</h2>
          </div>
          <div className="learning-steps">
            <article><h3>Set purposeful homework</h3><p>Use ready-made lessons to revisit classwork or prepare for a new topic. Set a practice test to check understanding. Choose what courses your students can access.</p></article>
            <article><h3>Feedback while students think</h3><p>Students get instant feedback in their lesson conversation and can ask for another explanation when they are stuck. Practice-tests are marked automatically and feedback is shared with the student.</p></article>
            <article><h3>See where help is needed</h3><p>Check who has started or completed an activity. Read lesson conversations and review test answers, marks and feedback to understand mistakes and decide what to revisit.</p></article>
          </div>
        </section>

        <div className="educator-section-grid tm-shell">
          <section className="learning-section" aria-labelledby="prepared-content">
            <div className="learning-section-heading">
              <h2 id="prepared-content">The lessons are planned. The conversations are personal.</h2>
              <p>TeachMeNow courses are organised into units and lessons, with prepared content and a planned teaching sequence. Students have a defined path to follow, while the AI tutor responds to their questions and answers within the lesson.</p>
              <p>Review the course outline, try the lessons and check the available practice before setting work. You choose the content that fits your class and use the resulting conversations and answers alongside your own assessment.</p>
            </div>
          </section>

          <section className="learning-section" aria-labelledby="educator-start">
            <div className="learning-section-heading">
              <h2 id="educator-start">Try the experience yourself before setting the work.</h2>
              <p>Choose a course and work through a lesson as a learner. If your school or organisation already uses TeachMeNow, ask its administrator to add you as a teacher and assign your classes. Your account will then show the Manage area for class access and progress.</p>
            </div>
            <Link className="tm-button tm-button--primary" to="/subjects">Find a course to try <span aria-hidden="true">→</span></Link>
          </section>
        </div>
      </main>
      <LearningFooter />
    </div>
  );
}
